import { Component } from "@angular/core";
import { AppState } from "@app/reducers";
import { moduleBasedComponentPermissionsSelector$, OnDemandPreloadService, sidebarDataSelector$ } from "@app/shared";
import { LoggedInUserModel } from "@app/shared/utils";
import { IApplicationResponse } from "@app/shared/utils/interfaces.utils";
import { loggedInUserData } from "@modules/others";
import { select, Store } from "@ngrx/store";
import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";
@Component({
  selector: "[app-sidebar]",
  templateUrl: "./app-sidebar.component.html"
})
export class AppSidebar {
  applicationResponse: IApplicationResponse;
  loggedInUserData: LoggedInUserModel;
  childMenus = [];
  parentBasedMenus = [];
  accessibleRoutes$: Observable<any>;

  constructor(private store: Store<AppState>, private preloadOnDemandService: OnDemandPreloadService) {
    this.combineLatestNgrxStoreData();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(moduleBasedComponentPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      this.parentBasedMenus = response[1];
    });
  }

  ngOnInit() {
    this.accessibleRoutes$ = this.store.pipe(select(sidebarDataSelector$)).pipe(map((sidebarData) => sidebarData?.['modules']));
  }

  async onSidebarModuleSectionClicked(selectedModuleObj, selectedSidebarType: string) {
    let selectedModule = { ...selectedModuleObj };
    // preload lazy loaded modules based on sidebar clicks
    switch (selectedSidebarType) {
      case "firstlevelHeader":
        let moduleName = selectedModule?.moduleName.toLowerCase();
        let preloadTopLevelModuleName;
        switch (true) {
          case moduleName.includes('customer'):
            break;
          case moduleName.includes('technical management'):
            preloadTopLevelModuleName = 'technical-management';
            break;
          case moduleName.includes('it management'):
            preloadTopLevelModuleName = 'user';
            break;
        }
        this.preloadOnDemandService.startPreload(preloadTopLevelModuleName);
        setTimeout(() => {
          selectedModule.navigations.forEach((childNavigationObj) => {
            if (childNavigationObj?.navigationUrl && childNavigationObj?.navigations?.length == 0) {
              let lazyLoadUrl = childNavigationObj.navigationUrl.split('/')[2];
              this.preloadOnDemandService.startPreload(lazyLoadUrl);
            }
          });
        }, 200);
        break;
      case "firstlevelChild":
        break;
      case "secondlevelHeader":
        selectedModule.navigations.forEach((nestedChildNavigationObj) => {
          if (nestedChildNavigationObj?.navigationUrl && (!nestedChildNavigationObj.navigations || nestedChildNavigationObj?.navigations?.length == 0)) {
            let lazyLoadUrl = nestedChildNavigationObj.navigationUrl.split('/')[2];
            this.preloadOnDemandService.startPreload(lazyLoadUrl);
          }
        });
        break;
      case "secondlevelChild":
        break;
    }
  }
}
